import { trackInternalEvent } from '@rio/tracking'
import { useEffect } from 'react'
import { RecommendJobAlertPage } from 'builder/components/FindJob/JobAlertPage/RecommendJobAlertPage'

export const RecommendJobAlertPageView = () => {
  useEffect(() => {
    trackInternalEvent('visit_job_ad_mjs', {
      label: 'recommendation',
    })
  }, [])
  return <RecommendJobAlertPage />
}
